var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H1C0.447715 0 0 0.447715 0 1V9C0 9.55228 0.447715 10 1 10H16C16.5523 10 17 9.55228 17 9V1C17 0.447715 16.5523 0 16 0Z",
    fill: "#E0B334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50025 6.344C8.43727 6.344 8.37493 6.32475 8.32039 6.28625L0.378135 0.6802C0.228795 0.57501 0.188539 0.36119 0.287882 0.203061C0.387225 0.0449306 0.588508 0.00230425 0.737848 0.107495L8.4996 5.58704L16.2614 0.107495C16.4107 0.00230425 16.612 0.0449306 16.7113 0.203061C16.8107 0.36119 16.7704 0.574322 16.6211 0.679513L8.6801 6.28625C8.62556 6.32475 8.56323 6.344 8.50025 6.344Z",
    fill: "#281009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.643454 9.93722C0.494115 9.93722 0.344126 9.87671 0.230499 9.75571C0.00259414 9.51439 0.00259414 9.1225 0.230499 8.88049L5.00741 3.82308C5.23596 3.58176 5.60541 3.58176 5.83397 3.82308C6.06187 4.0644 6.06187 4.45629 5.83397 4.6983L1.05706 9.75571C0.942782 9.87671 0.792794 9.93722 0.643454 9.93722Z",
    fill: "#281009"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 9.93722C16.1631 9.93722 16.0131 9.87671 15.8995 9.75571L11.1226 4.6983C10.8947 4.45698 10.8947 4.06509 11.1226 3.82308C11.3511 3.58176 11.7206 3.58176 11.9491 3.82308L16.7261 8.88049C16.954 9.12181 16.954 9.5137 16.7261 9.75571C16.6111 9.87671 16.4618 9.93722 16.3125 9.93722Z",
    fill: "#281009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.54a8b6683e2d46cc0c3dc53d2b7cd497.svg";
export { ForwardRef as ReactComponent };